import angular from 'angular';
import toolbarService from "../../../../Toolbar/ToolbarService";
import sectionsLibraryService from "../../../SectionsLibraryService";
import Width from "../../../../ConfigParameters/ConfigParameters/Width";
import Placeholder from "../../../../ConfigParameters/ConfigParameters/Placeholder";
import Label from "../../../../ConfigParameters/ConfigParameters/Label";
import BackgroundColor from "../../../../ConfigParameters/ConfigParameters/BackgroundColor";
import TextColor from "../../../../ConfigParameters/ConfigParameters/TextColor";
import FontSize from "../../../../ConfigParameters/ConfigParameters/FontSize";
import FontWeight from '../../../../ConfigParameters/ConfigParameters/FontWeight';
import Paddings from "../../../../ConfigParameters/ConfigCollections/Paddings";
import Margins from "../../../../ConfigParameters/ConfigCollections/Margins";
import Borders from "../../../../ConfigParameters/ConfigCollections/Borders";
import ConfigParameter from "../../../../ConfigParameters/ConfigParameter";
import CustomClassName from "../../../../ConfigParameters/ConfigParameters/CustomClassName";

const MODULE_NAME = 'formSubmit';

const creatorFormInputSubmit = {
    bindings: {
        elementModel: '=',
        parentModel: '<',
    },
    controller: function (ToolbarService) {
        let defaultConfig = ToolbarService.getSectionDefaultSchema(MODULE_NAME);

        this.$onInit = () => {
            this.elementModel = angular.copy(angular.extend(defaultConfig, this.elementModel));
        };
    },
    template: require('./submitInput.html')
};

export default angular.module('cms.creator.form.input.submit', [sectionsLibraryService, toolbarService])
    .run(function (ToolbarService, gettext, SectionsLibraryService, UniqueIdGenerator) {

        SectionsLibraryService.registerSection({
            icon: 'expand',
            type: MODULE_NAME,
            label: gettext('Submit'),
            group: 'form',
            hidden: true,
            options: {
                disableRemove: true,
                disableCopy: true,
            },
            groups: {
                mainConfig: {
                    label: gettext('Main config'),
                    isOpen: true,
                    type: 'mainConfig'
                },
                borders: {
                    label: gettext('Button borders'),
                    isOpen: false,
                    type: 'borders'
                },
                position: {
                    label: gettext('Position'),
                    isOpen: false,
                    type: 'position'
                },
                advanced: {
                    label: gettext('Advanced'),
                    isOpen: false,
                    type: 'advanced'
                }
            }
        });

        let placeholder = new Placeholder();
        placeholder.setInputType('hidden');

        let backgroundColor = new BackgroundColor();
        backgroundColor.setDefaultValue('#2dacd1');

        let textColor = new TextColor();
        textColor.setDefaultValue('#ffffff');

        ToolbarService.registerSectionSchema(MODULE_NAME, {
            ...(new ConfigParameter('uid', 'hidden',  '', null, () => UniqueIdGenerator.generate('element-uid'))),
            ...(new Label()),
            ...(placeholder),
            ...(new Width()),
            ...(backgroundColor),
            ...(new Borders('#2dacd1')),
            ...(textColor),
            ...(new FontSize()),
            ...(new FontWeight()),
            ...(new Margins({value: 0, unit: 'px'}, {value: 0, unit: 'px'})),
            ...(new Paddings({value: 6, unit: 'px'}, {value: 12, unit: 'px'})),
            ...(new CustomClassName())
        })
    })
    .component('cmsCreatorFormInputSubmit', creatorFormInputSubmit).name;



// WEBPACK FOOTER //
// ./src/cmsCore/Creator/SectionsLibrary/Sections/Form/SumbitInput/submitInput.js